module.exports = __webpack_public_path__ + "d5e752960891608625d013a9ca88435f.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/devicon/devicon.woff
 ** module id = ./src/styles/fonts/devicon/devicon.woff
 ** module chunks = 0
 **/